<script setup lang="ts">
  import SupportTicketDialog from './SupportTicketDialog.vue';

  const isDialogVisible = ref(false);
  const route = useRoute();
  const isOnHomePage = computed(() => route.name === 'agency-home');

  const scrolled = ref(false);

  const onScroll = () => {
    scrolled.value = window.scrollY > 300;
  };

  onMounted(() => window.addEventListener('scroll', onScroll, { passive: true }));
  onUnmounted(() => window.removeEventListener('scroll', onScroll));

  const showSupport = computed(() => isOnHomePage.value && !scrolled.value);
</script>

<template>
  <div>
    <Transition name="fab-fade">
      <VBtn
        v-if="showSupport"
        icon
        color="primary"
        size="large"
        elevation="4"
        style="position: fixed; bottom: 28px; right: 28px; z-index: 999"
        @click="isDialogVisible = true"
      >
        <VIcon icon="tabler-headset" size="24" />
        <VTooltip activator="parent" location="start" text="Contact Support" />
      </VBtn>
    </Transition>

    <SupportTicketDialog v-model:is-dialog-visible="isDialogVisible" />
  </div>
</template>

<style scoped>
  .fab-fade-enter-active,
  .fab-fade-leave-active {
    transition:
      opacity 0.2s ease,
      transform 0.2s ease;
  }

  .fab-fade-enter-from,
  .fab-fade-leave-to {
    opacity: 0;
    transform: scale(0.7);
  }
</style>
